export default __webpack_public_path__ + "static/media/cLogo15.62986556.jpeg";